
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.3585 4.83546C1.3585 3.61457 2.31057 2.62409 3.48411 2.62409H13.6948V4.42336C13.6948 4.74995 13.9493 5.0147 14.2632 5.0147C14.5771 5.0147 14.8316 4.74995 14.8316 4.42336V2.03275C14.8316 1.70616 14.5771 1.44141 14.2632 1.44141H3.48411C1.68272 1.44141 0.22168 2.96139 0.22168 4.83546V16.0473C0.22168 17.9214 1.68272 19.4414 3.48411 19.4414H16.9592C18.7606 19.4414 20.2217 17.9214 20.2217 16.0473V7.63817C20.2217 7.31158 19.9672 7.04683 19.6533 7.04683H3.48411C2.30955 7.04683 1.3585 6.05741 1.3585 4.83546ZM1.3585 16.0473V7.41075C1.92937 7.92114 2.67199 8.22952 3.48411 8.22952H19.0849V16.0473C19.0849 17.2683 18.1328 18.2587 16.9592 18.2587H3.48411C2.31056 18.2587 1.3585 17.2683 1.3585 16.0473ZM15.739 14.6528C16.4847 14.6528 17.0892 14.0239 17.0892 13.2481C17.0892 12.4722 16.4847 11.8433 15.739 11.8433C14.9932 11.8433 14.3887 12.4722 14.3887 13.2481C14.3887 14.0239 14.9932 14.6528 15.739 14.6528Z","fill":"#8338EC"}})])
          )
        }
      }
    